export default __webpack_public_path__ + "static/media/button_enable.b718b127.mp3";